import { KyInstance } from 'ky';
import qs from 'qs';

import { CommonResponseSingle, CommonQueryParams } from '../common';
import { DashboardBanner } from './dashboard-banner.model';

export async function getDashboardBanner(
  httpClient: KyInstance,
  options: CommonQueryParams,
): Promise<CommonResponseSingle<DashboardBanner>> {
  const searchParams = qs.stringify({ ...options, populate: '*' });
  const response = await httpClient.get('dashboard-banner', {
    searchParams,
  });
  return response.json();
}
